export function maxiumSeatsBooked(id, maximum, selectedSeats) {
  const seats = selectedSeats?.data.filter((obj) => obj.category_id === id);
  if (seats.length < Number(maximum)) {
    return true;
  } else {
    return false;
  }
}
